const REQUEST_A_TEMPLATE_URL = "https://airtable.com/shrDDbSTfYF88B13i";

export const CUSTOMER_CASE_STUDY_STORE_DATA = {
  cTitle: "Customer Case Study",
  cDescription:
    "You’re previewing a live shop created by one of our users. This user might have uploaded their own logo and banner, which isn’t available to duplicate. Not sure where to start? ",
  cCtaText: "Request a Template",
  cAnchorLink: REQUEST_A_TEMPLATE_URL,
};
